import { useEffect, useRef } from "react";
import { SITE } from "@shared/site/site-config";
import { HeroStage } from "./HeroStage";
import { useTouchReactions } from "./useTouchReactions";
import "./hero.css";

export function HomePage() {
  useEffect(() => {
    document.title = `${SITE.name} | ${SITE.tagline}`;
  }, []);

  const picture = useRef<HTMLElement>(null);
  useTouchReactions(picture);

  return (
    <main className="hero" id="main" ref={picture}>
      <HeroStage />
    </main>
  );
}
